import React, { useCallback, useState } from "react";
import ChangeFieldTypeModal from "views/logic/fieldactions/ChangeFieldType/ChangeFieldTypeModal";
import { isFunction } from "views/logic/aggregationbuilder/Series";
import isReservedField from "views/logic/IsReservedField";
import useInitialSelection from "views/logic/fieldactions/ChangeFieldType/hooks/useInitialSelection";
import { isPermitted } from "util/PermissionsMixin";
const ChangeFieldType = ({ field, onClose }) => {
  const [show, setShow] = useState(true);
  const handleOnClose = useCallback(() => {
    setShow(false);
    onClose();
  }, [onClose]);
  const { list, isLoading } = useInitialSelection();
  return show ? /* @__PURE__ */ React.createElement(
    ChangeFieldTypeModal,
    {
      initialSelectedIndexSets: list,
      onClose: handleOnClose,
      initialData: { fieldName: field },
      show: true,
      initialSelectionDataLoaded: !isLoading
    }
  ) : null;
};
const hasMappingPermission = (currentUser) => isPermitted(currentUser == null ? void 0 : currentUser.permissions, "typemappings:edit");
export const isChangeFieldTypeEnabled = ({ field, type, contexts }) => {
  const { currentUser } = contexts;
  return !isFunction(field) && !type.isDecorated() && !isReservedField(field) && hasMappingPermission(currentUser);
};
export const ChangeFieldTypeHelp = ({ contexts }) => {
  const { currentUser } = contexts;
  hasMappingPermission(currentUser);
  if (hasMappingPermission(currentUser)) return null;
  return { title: "No permission", description: "You don't have permission to do that action" };
};
export default ChangeFieldType;
